export type Lang = 'fr' | 'en'

const translations = {
  fr: {
    // ── Profile ──────────────────────────────────────────────
    member_badge: 'Membre Solim',
    trips: 'Voyages',
    fcfa_spent: 'FCFA dépensés',
    member_since: 'Membre depuis',
    statistics: 'Statistiques',
    history: 'Historique',
    section_info: 'Informations',
    full_name: 'Nom complet',
    phone: 'Téléphone',
    email: 'Email',
    section_security: 'Sécurité',
    change_password: 'Changer le mot de passe',
    change_password_sub: 'Modifier votre mot de passe actuel',
    section_prefs: 'Préférences',
    notifications: 'Notifications',
    notif_on: 'Alertes de voyage activées',
    notif_off: 'Notifications désactivées',
    language: 'Langue',
    lang_fr: 'Français',
    lang_en: 'English',
    section_help: 'Aide & Support',
    suggest: 'Faire une suggestion',
    suggest_sub: 'Partagez vos idées et retours',
    logout: 'Se déconnecter',
    logout_sub: "Retour à l'écran de connexion",
    edit_profile: 'Modifier le profil',
    gender: 'Genre',
    first_name: 'Prénom',
    last_name: 'Nom',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    pwd_current: 'Mot de passe actuel',
    pwd_new: 'Nouveau mot de passe',
    pwd_confirm: 'Confirmer le nouveau mot de passe',
    pwd_min: 'Minimum 6 caractères',
    pwd_change_btn: 'Modifier le mot de passe',
    pwd_changing: 'Modification...',
    password: 'Mot de passe',
    // ── Nav tabs ─────────────────────────────────────────────
    tab_home: 'Accueil',
    tab_tickets: 'Billets',
    tab_packages: 'Colis',
    tab_profile: 'Profil',
    tab_notif: 'Alertes',
    // ── Nav labels (UltraResponsiveNav) ──────────────────────
    nav_home: 'Accueil',
    nav_search: 'Réserver',
    nav_tickets: 'Tickets',
    nav_packages: 'Colis',
    nav_profile: 'Profil',
    nav_dark: 'Passer en mode sombre',
    nav_light: 'Passer en mode clair',
    // ── HomePage ─────────────────────────────────────────────
    welcome: 'Bienvenue',
    traveler: 'Voyageur',
    where_to_go: 'Où souhaitez-vous aller ?',
    departure: 'Départ',
    arrival: 'Arrivée',
    choose_city: 'Choisir une ville',
    swap_cities: 'Inverser départ et arrivée',
    date: 'Date',
    passengers: 'Passagers',
    add_passenger: 'Ajouter un passager',
    remove_passenger: 'Retirer un passager',
    search_trip: 'Rechercher un trajet',
    next_trip: 'Prochain voyage',
    current_offers: 'Offres du moment',
    popular_destinations: 'Destinations populaires',
    see_all: 'Voir tout',
    our_buses: 'Nos bus',
    book: 'Réserver',
    my_tickets: 'Mes billets',
    packages: 'Colis',
    bus_tracking: 'Suivi bus',
    notifications_aria: 'Notifications',
    // ── TicketsPage ──────────────────────────────────────────
    my_tickets_title: 'Mes Tickets',
    ticket_no: 'Ticket N°',
    seat: 'Siège',
    invitation: 'Invitation',
    see_details: 'Voir détails',
    no_ticket_today: 'Aucun ticket ce jour',
    no_ticket: 'Aucun ticket',
    no_reservation_on_date: 'Aucune réservation le',
    no_ticket_yet: "Vous n'avez pas encore de ticket",
    book_trip: 'Réserver un voyage',
    loading_tickets_error: 'Erreur lors du chargement des tickets',
    // ── HistoryPage ──────────────────────────────────────────
    history_title: 'Historique',
    voyages_label: 'Voyages',
    packages_label: 'Colis',
    search_trip_placeholder: 'Rechercher un voyage…',
    search_package_placeholder: 'Rechercher un colis…',
    no_result: 'Aucun résultat',
    no_trip: 'Aucun voyage',
    no_package: 'Aucun colis',
    try_other_keywords: "Essayez avec d'autres mots-clés",
    trip_history_empty: 'Votre historique de voyages apparaîtra ici',
    package_history_empty: 'Votre historique de colis apparaîtra ici',
    tracking_no: 'N° suivi',
    // ── NotificationsPage ────────────────────────────────────
    notif_title: 'Notifications',
    notif_loading: 'Chargement...',
    notif_empty: 'Aucune notification',
    notif_empty_sub: 'Vous serez averti ici des informations importantes.',
    notif_sponsored: 'Sponsorisé',
    notif_mark_read: 'Marquer comme lu',
    // ── StatsPage ────────────────────────────────────────────
    stats_title: 'Statistiques',
    total_trips: 'Voyages totaux',
    confirmed: 'Confirmés',
    total_spent: 'Total dépensé',
    cities_visited: 'Villes visitées',
    monthly_spending: 'Dépenses mensuelles',
    avg_per_trip: 'Moy.',
    per_trip: '/ voyage',
    trip_status: 'Statut des voyages',
    success_rate: 'Taux réussite',
    avg_price: 'Prix moyen',
    cities: 'Villes',
    frequent_routes: 'Trajets fréquents',
    destinations_spending: 'Destinations · dépenses',
    no_data_yet: 'Pas encore de données',
    no_data_sub: 'Vos statistiques apparaîtront après vos premiers voyages',
    // ── LoginPage ────────────────────────────────────────────
    welcome_back: 'Welcome Back',
    sign_in_subtitle: 'Sign in to continue your journey.',
    phone_label: 'Téléphone',
    email_label: 'Email',
    switch_to_email: 'Passer à Email',
    switch_to_phone: 'Passer à Téléphone',
    password_label: 'Mot de passe',
    forgot_password: 'Oublié ?',
    sign_in: 'Se connecter',
    already_at_counter: 'Déjà réservé au guichet ? Créer mon mot de passe',
    no_account: 'Pas encore de compte ?',
    register: "S'inscrire",
    show_password: 'Afficher le mot de passe',
    hide_password: 'Masquer le mot de passe',
    fill_all_fields: 'Veuillez remplir tous les champs',
    // ── RegisterPage ─────────────────────────────────────────
    create_account: 'Créer un compte',
    register_subtitle: "Vivez l'expérience premium africaine.",
    last_name_required: 'Nom *',
    first_name_required: 'Prénom *',
    email_optional: 'Email (optionnel)',
    phone_required: 'Téléphone *',
    password_required: 'Mot de passe *',
    confirm_required: 'Confirmer *',
    privacy_accept: "J'ai lu et j'accepte la",
    privacy_policy: 'Politique de confidentialité',
    terms: "Conditions d'utilisation",
    terms_of_solim: 'de Solim Transport.',
    create_account_btn: 'Créer mon compte',
    already_account: 'Déjà un compte ?',
    terms_note: "En créant un compte, vous acceptez nos",
    fill_required: 'Veuillez remplir tous les champs obligatoires',
    passwords_mismatch: 'Les mots de passe ne correspondent pas',
    pwd_too_short: 'Le mot de passe doit contenir au moins 6 caractères',
    // ── PaymentCancelled ─────────────────────────────────────
    payment_cancelled_title: 'Paiement Annulé',
    payment_cancelled_heading: 'Paiement annulé',
    payment_cancelled_desc: "Vous avez annulé le processus de paiement. Vous serez redirigé vers l'accueil dans quelques secondes.",
    payment_cancelled_status: 'Paiement annulé',
    payment_no_charge: "Aucun montant n'a été débité de votre compte.",
    what_now: 'Que faire maintenant ?',
    what_now_1: 'Vous pouvez refaire une réservation',
    what_now_2: 'Vérifiez les disponibilités',
    what_now_3: 'Contactez-nous si vous avez des questions',
    auto_redirect: "Redirection automatique vers l'accueil...",
    back_home: "Retour à l'accueil",
    new_reservation: 'Nouvelle réservation',
    payment_cancelled_toast: 'Paiement annulé',
    // ── SuggestionPage ───────────────────────────────────────
    suggestion_title: 'Faire une suggestion',
    back: 'Retour',
    share_ideas: 'Partagez vos idées',
    share_ideas_sub: "Vos suggestions nous aident à améliorer l'application. Nous lisons chaque message et prenons en compte vos retours.",
    suggestion_title_label: 'Titre de votre suggestion *',
    suggestion_title_placeholder: 'Ex: Améliorer la recherche de trajets',
    type_label: 'Type',
    priority_label: 'Priorité',
    description_label: 'Description détaillée *',
    description_placeholder: 'Décrivez votre suggestion en détail. Plus vous êtes précis, mieux nous pourrons vous aider...',
    auto_info: 'Informations automatiques',
    auto_info_name: 'Nom :',
    auto_info_phone: 'Téléphone :',
    auto_info_note: 'Ces informations sont automatiquement associées à votre suggestion.',
    send_suggestion: 'Envoyer ma suggestion',
    sending: 'Envoi en cours...',
    tips_title: 'Conseils pour une bonne suggestion',
    tip_1: 'Soyez précis et détaillé dans votre description',
    tip_2: "Expliquez le problème ou l'amélioration souhaitée",
    tip_3: 'Mentionnez les étapes pour reproduire un bug',
    tip_4: 'Proposez des solutions si vous en avez',
    suggestion_success: 'Votre suggestion a été envoyée avec succès !',
    suggestion_error_fields: 'Veuillez remplir tous les champs obligatoires',
    suggestion_error_auth: 'Vous devez être connecté pour soumettre une suggestion',
    // ── PackagesPage ─────────────────────────────────────────
    packages_title: 'Mes Colis',
    tracking_search_placeholder: 'N° de suivi, description…',
    filter_all: 'Tous',
    filter_registered: 'Enregistrés',
    filter_transit: 'En transit',
    filter_delivered: 'Livrés',
    no_package_empty: 'Aucun colis',
    no_package_filters: 'Aucun résultat pour ces filtres.',
    no_package_yet: "Vous n'avez pas encore de colis enregistré.",
    departure_label: 'Départ',
    arrival_label: 'Arrivée',
    registered_on: 'Enregistré',
    departure_time: 'Départ',
    qty_label: 'Qté',
    // ── AvailableTripsPage ───────────────────────────────────
    available_trips_title: 'Trajets Disponibles',
    travel_date: 'Date de voyage',
    departure_city: 'Ville de départ',
    loading_cities: 'Chargement des villes...',
    schedules_available: 'Horaires disponibles',
    hide_schedules: 'Masquer',
    show_schedules: 'Voir les horaires',
    seats_available: 'places disponibles',
    book_btn: 'Réserver',
    no_trip_available: 'Aucun trajet disponible',
    no_trip_available_sub: 'Aucun trajet ne correspond à vos critères de recherche pour',
    // ── BusTrackingPage ──────────────────────────────────────
    bus_tracking_title: 'Suivi des Bus',
    realtime_geoloc: 'Géolocalisation en temps réel',
    active_buses: 'Bus Actifs',
    online: 'En Ligne',
    search_bus_placeholder: 'Rechercher par bus, trajet ou chauffeur...',
    no_result_search: 'Aucun résultat',
    no_bus_tracked: 'Aucun bus en suivi',
    no_bus_match: 'Aucun bus ne correspond à votre recherche.',
    no_bus_gps: "Aucun bus n'est actuellement en cours de suivi GPS.",
    driver_label: 'Chauffeur',
    gps_position: 'Position GPS',
    last_update: 'Dernière mise à jour',
    view_on_map: 'Voir sur la carte',
    tracking_error: 'Erreur lors de la récupération des positions des bus',
    just_now: "À l'instant",
    minutes_ago: 'Il y a',
    min_suffix: 'min',
    hours_suffix: 'h',
    // ── SearchPage ───────────────────────────────────────────
    search_results_title: 'Résultats de recherche',
    filters: 'Filtres',
    trips_found: 'trajet(s) trouvé(s)',
    filter_all_time: 'Tous',
    filter_morning: 'Matin',
    filter_afternoon: 'Après-midi',
    filter_evening: 'Soir',
    sort_price: 'Prix',
    sort_time: 'Heure',
    sort_duration: 'Durée',
    per_person: 'par personne',
    select_btn: 'Sélectionner',
    full: 'Complet',
    no_trip_found: 'Aucun trajet trouvé',
    no_trip_found_sub: 'Aucun trajet disponible pour cette destination à cette date.',
    modify_search: 'Modifier la recherche',
    search_error: 'Erreur lors de la recherche des trajets',
    passenger_singular: 'passager',
    passenger_plural: 'passagers',
    // ── QuickBookingPage ─────────────────────────────────────
    quick_booking_title: 'Réservation rapide',
    hello_traveler: 'Voyageur',
    book_in_clicks: 'Réservez votre voyage en quelques clics',
    search_trip_title: 'Rechercher un voyage',
    from_city: 'Ville de départ',
    from_placeholder: "D'où partez-vous ?",
    to_city: "Ville d'arrivée",
    to_placeholder: 'Où allez-vous ?',
    passengers_label: 'Nombre de passagers',
    search_trips_btn: 'Rechercher des voyages',
    popular_destinations_title: 'Destinations populaires',
    quick_info_title: 'Informations rapides',
    frequent_departure: 'Départ fréquent',
    every_30_min: 'Toutes les 30 minutes',
    comfortable_buses: 'Bus confortables',
    ac_and_wifi: 'Climatisation et WiFi',
    // ── TicketDetailPage ─────────────────────────────────────
    ticket_detail_title: 'Détail ticket',
    ticket_not_found: 'Ticket introuvable',
    download_ticket: 'Télécharger le ticket',
    download_png: 'Image PNG',
    download_pdf: 'Document PDF',
    cancel: 'Annuler',
    generating_image: "Génération de l'image...",
    generating_pdf: 'Génération du PDF...',
    image_downloaded: 'Image téléchargée !',
    pdf_downloaded: 'PDF téléchargé !',
    ticket_ref_error: 'Référence du ticket non trouvée',
    ticket_load_error: 'Erreur lors du chargement du ticket',
    // ── PackageDetailPage ────────────────────────────────────
    package_detail_title: 'Détail colis',
    package_not_found: 'Colis introuvable',
    package_not_found_sub: "Ce colis n'existe pas ou vous n'y avez pas accès.",
    back_to_packages: 'Retour aux colis',
    tracking_label: 'N° de suivi',
    registered_label: 'Enregistré le',
    departure_time_label: 'Heure de départ',
    quantity_label: 'Quantité',
    weight_label: 'Poids',
    declared_value_label: 'Valeur déclarée',
    payment_label: 'Paiement',
    paid: 'Payé ✓',
    pending_payment: 'En attente',
    package_count: 'colis',
    sender_section: 'Expéditeur',
    recipient_section: 'Destinataire',
    bus_section: 'Bus',
    events_section: 'Historique de suivi',
  },
  en: {
    // ── Profile ──────────────────────────────────────────────
    member_badge: 'Solim Member',
    trips: 'Trips',
    fcfa_spent: 'FCFA spent',
    member_since: 'Member since',
    statistics: 'Statistics',
    history: 'History',
    section_info: 'Information',
    full_name: 'Full name',
    phone: 'Phone',
    email: 'Email',
    section_security: 'Security',
    change_password: 'Change password',
    change_password_sub: 'Update your current password',
    section_prefs: 'Preferences',
    notifications: 'Notifications',
    notif_on: 'Travel alerts enabled',
    notif_off: 'Notifications disabled',
    language: 'Language',
    lang_fr: 'French',
    lang_en: 'English',
    section_help: 'Help & Support',
    suggest: 'Make a suggestion',
    suggest_sub: 'Share your ideas and feedback',
    logout: 'Sign out',
    logout_sub: 'Back to login screen',
    edit_profile: 'Edit profile',
    gender: 'Gender',
    first_name: 'First name',
    last_name: 'Last name',
    save: 'Save',
    saving: 'Saving...',
    pwd_current: 'Current password',
    pwd_new: 'New password',
    pwd_confirm: 'Confirm new password',
    pwd_min: 'Minimum 6 characters',
    pwd_change_btn: 'Change password',
    pwd_changing: 'Changing...',
    password: 'Password',
    // ── Nav tabs ─────────────────────────────────────────────
    tab_home: 'Home',
    tab_tickets: 'Tickets',
    tab_packages: 'Packages',
    tab_profile: 'Profile',
    tab_notif: 'Alerts',
    // ── Nav labels (UltraResponsiveNav) ──────────────────────
    nav_home: 'Home',
    nav_search: 'Book',
    nav_tickets: 'Tickets',
    nav_packages: 'Packages',
    nav_profile: 'Profile',
    nav_dark: 'Switch to dark mode',
    nav_light: 'Switch to light mode',
    // ── HomePage ─────────────────────────────────────────────
    welcome: 'Welcome',
    traveler: 'Traveler',
    where_to_go: 'Where would you like to go?',
    departure: 'Departure',
    arrival: 'Arrival',
    choose_city: 'Choose a city',
    swap_cities: 'Swap departure and arrival',
    date: 'Date',
    passengers: 'Passengers',
    add_passenger: 'Add a passenger',
    remove_passenger: 'Remove a passenger',
    search_trip: 'Search for a trip',
    next_trip: 'Next trip',
    current_offers: 'Current offers',
    popular_destinations: 'Popular destinations',
    see_all: 'See all',
    our_buses: 'Our buses',
    book: 'Book',
    my_tickets: 'My tickets',
    packages: 'Packages',
    bus_tracking: 'Bus tracking',
    notifications_aria: 'Notifications',
    // ── TicketsPage ──────────────────────────────────────────
    my_tickets_title: 'My Tickets',
    ticket_no: 'Ticket N°',
    seat: 'Seat',
    invitation: 'Invitation',
    see_details: 'View details',
    no_ticket_today: 'No ticket today',
    no_ticket: 'No ticket',
    no_reservation_on_date: 'No reservation on',
    no_ticket_yet: "You don't have any ticket yet",
    book_trip: 'Book a trip',
    loading_tickets_error: 'Error loading tickets',
    // ── HistoryPage ──────────────────────────────────────────
    history_title: 'History',
    voyages_label: 'Trips',
    packages_label: 'Packages',
    search_trip_placeholder: 'Search a trip…',
    search_package_placeholder: 'Search a package…',
    no_result: 'No results',
    no_trip: 'No trips',
    no_package: 'No packages',
    try_other_keywords: 'Try with other keywords',
    trip_history_empty: 'Your trip history will appear here',
    package_history_empty: 'Your package history will appear here',
    tracking_no: 'Tracking N°',
    // ── NotificationsPage ────────────────────────────────────
    notif_title: 'Notifications',
    notif_loading: 'Loading...',
    notif_empty: 'No notifications',
    notif_empty_sub: 'You will be notified here of important information.',
    notif_sponsored: 'Sponsored',
    notif_mark_read: 'Mark as read',
    // ── StatsPage ────────────────────────────────────────────
    stats_title: 'Statistics',
    total_trips: 'Total trips',
    confirmed: 'Confirmed',
    total_spent: 'Total spent',
    cities_visited: 'Cities visited',
    monthly_spending: 'Monthly spending',
    avg_per_trip: 'Avg.',
    per_trip: '/ trip',
    trip_status: 'Trip status',
    success_rate: 'Success rate',
    avg_price: 'Avg. price',
    cities: 'Cities',
    frequent_routes: 'Frequent routes',
    destinations_spending: 'Destinations · spending',
    no_data_yet: 'No data yet',
    no_data_sub: 'Your statistics will appear after your first trips',
    // ── LoginPage ────────────────────────────────────────────
    welcome_back: 'Welcome Back',
    sign_in_subtitle: 'Sign in to continue your journey.',
    phone_label: 'Phone',
    email_label: 'Email',
    switch_to_email: 'Switch to Email',
    switch_to_phone: 'Switch to Phone',
    password_label: 'Password',
    forgot_password: 'Forgot?',
    sign_in: 'Sign in',
    already_at_counter: 'Already booked at the counter? Create my password',
    no_account: 'No account yet?',
    register: 'Sign up',
    show_password: 'Show password',
    hide_password: 'Hide password',
    fill_all_fields: 'Please fill in all fields',
    // ── RegisterPage ─────────────────────────────────────────
    create_account: 'Create account',
    register_subtitle: 'Experience the premium African journey.',
    last_name_required: 'Last name *',
    first_name_required: 'First name *',
    email_optional: 'Email (optional)',
    phone_required: 'Phone *',
    password_required: 'Password *',
    confirm_required: 'Confirm *',
    privacy_accept: 'I have read and accept the',
    privacy_policy: 'Privacy Policy',
    terms: 'Terms of Use',
    terms_of_solim: 'of Solim Transport.',
    create_account_btn: 'Create my account',
    already_account: 'Already have an account?',
    terms_note: 'By creating an account, you agree to our',
    fill_required: 'Please fill in all required fields',
    passwords_mismatch: 'Passwords do not match',
    pwd_too_short: 'Password must be at least 6 characters',
    // ── PaymentCancelled ─────────────────────────────────────
    payment_cancelled_title: 'Payment Cancelled',
    payment_cancelled_heading: 'Payment cancelled',
    payment_cancelled_desc: 'You cancelled the payment process. You will be redirected to the home page in a few seconds.',
    payment_cancelled_status: 'Payment cancelled',
    payment_no_charge: 'No amount has been charged to your account.',
    what_now: 'What to do now?',
    what_now_1: 'You can make a new reservation',
    what_now_2: 'Check availability',
    what_now_3: 'Contact us if you have questions',
    auto_redirect: 'Automatic redirect to home...',
    back_home: 'Back to home',
    new_reservation: 'New reservation',
    payment_cancelled_toast: 'Payment cancelled',
    // ── SuggestionPage ───────────────────────────────────────
    suggestion_title: 'Make a suggestion',
    back: 'Back',
    share_ideas: 'Share your ideas',
    share_ideas_sub: 'Your suggestions help us improve the app. We read every message and take your feedback into account.',
    suggestion_title_label: 'Suggestion title *',
    suggestion_title_placeholder: 'Ex: Improve trip search',
    type_label: 'Type',
    priority_label: 'Priority',
    description_label: 'Detailed description *',
    description_placeholder: 'Describe your suggestion in detail. The more precise you are, the better we can help...',
    auto_info: 'Automatic information',
    auto_info_name: 'Name:',
    auto_info_phone: 'Phone:',
    auto_info_note: 'This information is automatically associated with your suggestion.',
    send_suggestion: 'Send my suggestion',
    sending: 'Sending...',
    tips_title: 'Tips for a good suggestion',
    tip_1: 'Be precise and detailed in your description',
    tip_2: 'Explain the problem or desired improvement',
    tip_3: 'Mention steps to reproduce a bug',
    tip_4: 'Propose solutions if you have any',
    suggestion_success: 'Your suggestion was sent successfully!',
    suggestion_error_fields: 'Please fill in all required fields',
    suggestion_error_auth: 'You must be logged in to submit a suggestion',
    // ── PackagesPage ─────────────────────────────────────────
    packages_title: 'My Packages',
    tracking_search_placeholder: 'Tracking N°, description…',
    filter_all: 'All',
    filter_registered: 'Registered',
    filter_transit: 'In transit',
    filter_delivered: 'Delivered',
    no_package_empty: 'No packages',
    no_package_filters: 'No results for these filters.',
    no_package_yet: "You don't have any registered package yet.",
    departure_label: 'Departure',
    arrival_label: 'Arrival',
    registered_on: 'Registered',
    departure_time: 'Departure',
    qty_label: 'Qty',
    // ── AvailableTripsPage ───────────────────────────────────
    available_trips_title: 'Available Trips',
    travel_date: 'Travel date',
    departure_city: 'Departure city',
    loading_cities: 'Loading cities...',
    schedules_available: 'Available schedules',
    hide_schedules: 'Hide',
    show_schedules: 'View schedules',
    seats_available: 'seats available',
    book_btn: 'Book',
    no_trip_available: 'No trips available',
    no_trip_available_sub: 'No trips match your search criteria for',
    // ── BusTrackingPage ──────────────────────────────────────
    bus_tracking_title: 'Bus Tracking',
    realtime_geoloc: 'Real-time geolocation',
    active_buses: 'Active Buses',
    online: 'Online',
    search_bus_placeholder: 'Search by bus, route or driver...',
    no_result_search: 'No results',
    no_bus_tracked: 'No bus being tracked',
    no_bus_match: 'No bus matches your search.',
    no_bus_gps: 'No bus is currently being tracked via GPS.',
    driver_label: 'Driver',
    gps_position: 'GPS Position',
    last_update: 'Last update',
    view_on_map: 'View on map',
    tracking_error: 'Error retrieving bus positions',
    just_now: 'Just now',
    minutes_ago: '',
    min_suffix: 'min ago',
    hours_suffix: 'h ago',
    // ── SearchPage ───────────────────────────────────────────
    search_results_title: 'Search results',
    filters: 'Filters',
    trips_found: 'trip(s) found',
    filter_all_time: 'All',
    filter_morning: 'Morning',
    filter_afternoon: 'Afternoon',
    filter_evening: 'Evening',
    sort_price: 'Price',
    sort_time: 'Time',
    sort_duration: 'Duration',
    per_person: 'per person',
    select_btn: 'Select',
    full: 'Full',
    no_trip_found: 'No trip found',
    no_trip_found_sub: 'No trips available for this destination on this date.',
    modify_search: 'Modify search',
    search_error: 'Error searching for trips',
    passenger_singular: 'passenger',
    passenger_plural: 'passengers',
    // ── QuickBookingPage ─────────────────────────────────────
    quick_booking_title: 'Quick booking',
    hello_traveler: 'Traveler',
    book_in_clicks: 'Book your trip in a few clicks',
    search_trip_title: 'Search for a trip',
    from_city: 'Departure city',
    from_placeholder: 'Where are you departing from?',
    to_city: 'Arrival city',
    to_placeholder: 'Where are you going?',
    passengers_label: 'Number of passengers',
    search_trips_btn: 'Search trips',
    popular_destinations_title: 'Popular destinations',
    quick_info_title: 'Quick information',
    frequent_departure: 'Frequent departures',
    every_30_min: 'Every 30 minutes',
    comfortable_buses: 'Comfortable buses',
    ac_and_wifi: 'Air conditioning and WiFi',
    // ── TicketDetailPage ─────────────────────────────────────
    ticket_detail_title: 'Ticket detail',
    ticket_not_found: 'Ticket not found',
    download_ticket: 'Download ticket',
    download_png: 'PNG Image',
    download_pdf: 'PDF Document',
    cancel: 'Cancel',
    generating_image: 'Generating image...',
    generating_pdf: 'Generating PDF...',
    image_downloaded: 'Image downloaded!',
    pdf_downloaded: 'PDF downloaded!',
    ticket_ref_error: 'Ticket reference not found',
    ticket_load_error: 'Error loading ticket',
    // ── PackageDetailPage ────────────────────────────────────
    package_detail_title: 'Package detail',
    package_not_found: 'Package not found',
    package_not_found_sub: "This package doesn't exist or you don't have access.",
    back_to_packages: 'Back to packages',
    tracking_label: 'Tracking N°',
    registered_label: 'Registered on',
    departure_time_label: 'Departure time',
    quantity_label: 'Quantity',
    weight_label: 'Weight',
    declared_value_label: 'Declared value',
    payment_label: 'Payment',
    paid: 'Paid ✓',
    pending_payment: 'Pending',
    package_count: 'packages',
    sender_section: 'Sender',
    recipient_section: 'Recipient',
    bus_section: 'Bus',
    events_section: 'Tracking history',
  },
} as const

export type TranslationKey = keyof typeof translations.fr

export const t = (lang: Lang, key: TranslationKey): string =>
  (translations[lang] as Record<string, string>)[key] ?? (translations.fr as Record<string, string>)[key]

export default translations
